import { ReactElement } from 'react';
import { NEW_NON_EMPLOYEE_KEYS } from 'pages/NewNonEmployee/_const';
import CustomTextField from '../base/CustomTextField';

/**
 * Prompt user for input: last name
 * @returns {ReactElement} textbox prompting for last name
 */
const LastName = () => {
	return (
		<CustomTextField
			name={NEW_NON_EMPLOYEE_KEYS.LAST_NAME}
			label='Last Name'
			required
		/>
	);
};
export default LastName;
